import script from "./AdviceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviceModal.vue?vue&type=script&setup=true&lang=js"

import "./AdviceModal.vue?vue&type=style&index=0&id=49c11461&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c11461"]])

export default __exports__